import React from "react"
import {
    Text,
    View,
    StyleSheet,
    TouchableOpacity,
    ActivityIndicator,
} from "react-native"

import { AuthContext } from '../../contexts/auth/Store';
import { GetPricetag } from '../../constants/Utils';

import { AnalyticsService } from "../../constants/Analytics";
import StyledIcon from "../StyledIcon";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import OrderItem from "./OrderItem";
import { OrderContext } from "../../contexts/order/Store";
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";

const analytics = new AnalyticsService()

function OrderGroupOrderCard({ order, orderGroup, canUpdate }) {
    const isMounted = useMounted()
    const auth = React.useContext(AuthContext)
    const buyer = auth.getUserData.buyerData
    const token = auth.getUserData.userToken

    const { action: order_fetch } = React.useContext(OrderContext);

    const [loading, setLoading] = React.useState(false)
    const [mutableOrder, setMutableOrder] = React.useState(order)
    const [orderItems, setOrderItems] = React.useState([])

    const readOrderItems = () => {
        setLoading(true)

        let form = new FormData()
        form.append('order_id', mutableOrder._id)
        http.post('order_item/read_by_order', form, token)
            .then(res => {
                if (isMounted.current) {
                    setLoading(false)
                    if (res.code === 200) {
                        let _list = res.data.map(item => {
                            item['product']['pricetag'] = GetPricetag(item?.product)
                            return item
                        }).filter(x => x?.product?.pricetag)
                        setOrderItems(_list)
                    }
                }
            })
            .catch(err => {
                isMounted.current && setLoading(false)
            })
    }

    const cancelOrder = () => {
        setLoading(true)

        let form = new FormData()
        form.append('_id', mutableOrder._id)
        form.append('sales_officer_id', mutableOrder.sales_officer_id)
        form.append('meta', mutableOrder.meta)
        form.append('old_tag', mutableOrder.tag)
        form.append('new_tag', 'cancelled')
        http.post('order/update_tag', form, token)
            .then(res => {
                analytics.logEvent('Cancelled Order', buyer, { order: mutableOrder })
                order_fetch()
                    .then(() => {})
                    .catch(() => { })
                isMounted.current && setMutableOrder({
                    ...mutableOrder,
                    tag: 'cancelled'
                })
            })
            .catch(err => {
                isMounted.current && setLoading(false)
            })
    }

    React.useEffect(() => {
        readOrderItems()
        return () => { }
    }, [])

    return <>
        {
            ['pending', 'completed'].includes(mutableOrder?.tag)
                ? <View key={mutableOrder._id} style={[styles.card]}>
                    <View style={styles.cardTitleWrapper}>
                        {/* <Text style={styles.cardTitleText}>{orderItem.length} item{orderItem.length > 1 ? 's' : null}</Text> */}
                        <Text style={styles.cardTitleText}>{order?.manufacturer?.name} ({orderItems.length} item{orderItems.length > 1 ? 's' : null})</Text>
                        {/* <OrderStatus type={mutableOrder.tag} /> */}
                    </View>
                    <View style={styles.hr}></View>
                    {
                        loading
                            ? <View style={styles.loaderContainer}>
                                <ActivityIndicator
                                    size={40}
                                    color={Colors.shades._7}
                                />
                            </View>
                            : orderItems && orderItems.length
                                ? orderItems.map(item =>
                                    <OrderItem
                                        item={item}
                                        key={item._id}
                                        order={order}
                                        // updateOrder={updateOrder}
                                        order_length={orderItems.length}
                                        can_update={canUpdate}
                                    />)
                                : null
                    }
                    {
                        canUpdate && orderGroup.tag === 'pending'
                            ? <View>
                                <TouchableOpacity
                                    onPress={cancelOrder}
                                    style={[styles.cancelButton, {
                                        opacity: loading ? 0.3 : 1
                                    }]}
                                    disabled={loading}
                                >
                                    <StyledIcon
                                        iconName="md-close"
                                        iconColor={Colors.dangerText}
                                        size={15}
                                        iconOnly
                                    />
                                    <Text style={styles.cancelButtonText}>Cancel Order</Text>
                                </TouchableOpacity>
                            </View>
                            : null
                    }
                </View>
                : null
        }
    </>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    scrollView: {
        width: '100%',
        paddingHorizontal: 16,
        flexGrow: 1,
        paddingBottom: 25
    },
    hr: {
        height: 1,
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
    loaderContainer: {
        borderBottomColor: 'rgba(0,0,0,0.05)',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        padding: 10,
    },
    card: {
        backgroundColor: Colors.whiteColor,
        marginTop: 10,
        elevation: 1
    },
    cardTitleWrapper: {
        flexDirection: 'row',
        paddingHorizontal: 16,
        paddingVertical: 16,
    },
    cardTitleText: {
        flexGrow: 1,
        flex: 1,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh18,
        ...FontStyles.medium,
    },
    summaryContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        padding: 16,
    },
    cancelButton: {
        flexDirection: 'row',
        minHeight: 40,
        alignItems: 'center',
        justifyContent: 'center',
    },
    cancelButtonText: {
        color: Colors.dangerText,
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.semibold,
        marginLeft: 4,
        textTransform: 'uppercase'
    },
})

export default OrderGroupOrderCard